import { sendGet } from '../helpers/axios';

export const apiSearchDashboard = (params) => sendGet('/api/search-dashboard', params);
